import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  visible: false
}

const billingMaintenanceSlice = createSlice({
  name: 'billingMaintenanceBanner',
  initialState,
  reducers: {
    showBillingMaintenanceBanner: () => ({ visible: true }),
    closeBillingMaintenanceBanner: () => ({ visible: false })
  }
})

export const {
  reducer,
  actions: {
    showBillingMaintenanceBanner,
    closeBillingMaintenanceBanner
  }
} = billingMaintenanceSlice
